import { Info } from "lucide-react";

/**
 * Pricing display components.
 *
 * 2026-07-24 — Per stakeholder direction, do NOT display numeric prices on
 * the treatments page, individual peptide detail pages, or the questionnaire
 * results. Publishing a fixed price for a specific peptide would be
 * misleading because every treatment plan is individualized (dosage, labs,
 * duration, monitoring). Instead, cost is discussed transparently with the
 * provider during the consultation, and the /pricing page carries the
 * philosophy.
 *
 * We keep the components' export signatures intact so existing callers
 * (TherapyCard, TherapyDetail, questionnaire results) continue to compile.
 * Each one now returns null unconditionally.
 *
 * To bring prices back in the future, revert this file to the git blob at
 * commit prior to 2026-07-24.
 */
// Kept for future revert; unused while prices are hidden.
// eslint-disable-next-line no-unused-vars
const fmt = (n) => `$${Number(n).toLocaleString()}`;

// eslint-disable-next-line no-unused-vars
export function StartingAtPill({ price, promo, size = "sm", testId }) {
  return null;
}

// eslint-disable-next-line no-unused-vars
export function PricingBlock({ therapy, testId = "pricing-block" }) {
  return null;
}

// eslint-disable-next-line no-unused-vars
export function TierTotal({ total, testId }) {
  return null;
}

// Also exported in case any page uses this to show the disclaimer only.
export function PricingIndividualizedNote({ testId = "pricing-individualized-note" }) {
  return (
    <div
      data-testid={testId}
      className="rounded-2xl border border-stone-200 bg-stone-50 p-4 md:p-5 text-xs text-stone-600 flex items-start gap-2 leading-relaxed"
    >
      <Info size={14} className="text-[color:var(--vv-teal)] mt-0.5 flex-shrink-0" />
      Because every treatment plan is individualized, treatment cost varies. Your provider reviews all costs with you during your consultation before any therapy begins.
    </div>
  );
}
